import moment from 'moment';
let content_blocks = require('../contents');

export function init(){
    
    $('#edit_speakers_modal .btn.delete').on('click', function(){
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        $('#'+block_id).remove();
        content_blocks.show_start_block();
        content_blocks.show_block_order();

        modal.modal('hide');

        modal.find('form')[0].reset();
    });

    $('#edit_speakers').find('.visibility-devices span').each(function(){
        $(this).on('click', function(){
            let hidden = $(this).attr('data-hidden') == true || $(this).attr('data-hidden') == 'true' ? true : false;
            change_device_visible($(this), !hidden);
            $(this).attr('data-hidden', !hidden);
        });
    });

    function change_device_visible(button, hidden){
        if (hidden == true || hidden == 'true') {
            button.css({"background-color": "#f8f9fa"});
        } else {
            button.css({"background-color": "#d3d6d9"});
        }
    }

    $('#edit_speakers_modal').on('show.bs.modal', function (event) {

        let button = $(event.relatedTarget);
        let block = $(button).closest('.block');
        let modal = $(this);

        modal.find('[name="block_id"]').val(block.attr('id'));
        modal.find('[name="classes"]').val(block.attr('data-class'));

        let device_mobile = modal.find('.visibility-devices [data-device="mobile"]');
        device_mobile.attr('data-hidden', block.attr('data-mobile-hidden'));
        change_device_visible(device_mobile, block.attr('data-mobile-hidden'));
        
        let device_tablet = modal.find('.visibility-devices  [data-device="tablet"]');
        device_tablet.attr('data-hidden', block.attr('data-tablet-hidden'));
        change_device_visible(device_tablet, block.attr('data-tablet-hidden'));
        
        let device_desktop = modal.find('.visibility-devices [data-device="desktop"]');
        device_desktop.attr('data-hidden', block.attr('data-desktop-hidden'));
        change_device_visible(device_desktop, block.attr('data-desktop-hidden'));

        modal.find('[name="photo"]').prop('checked', block.attr('data-photo') == "true" ? true : false);
        modal.find('[name="title"]').prop('checked', block.attr('data-title') == "true" ? true : false);
        modal.find('[name="position"]').prop('checked', block.attr('data-position') == "true" ? true : false);
        modal.find('[name="work_place"]').prop('checked', block.attr('data-work-place') == "true" ? true : false);
        modal.find('[name="moderators"]').prop('checked', block.attr('data-moderators') == "true" ? true : false);
        modal.find('[name="speakers"]').prop('checked', block.attr('data-speakers') == "true" ? true : false);
        modal.find('[name="communicators"]').prop('checked', block.attr('data-communicators') == "true" ? true : false);

        modal.find('[name="show_details"]').prop('checked', block.attr('data-show-details') == "true" ? true : false);
        change_show_details(modal, block);

        let select_visible = modal.find('[name="visible"]');
        if (block.attr('data-visible') != null || block.attr('data-visible') != 'undefined') {
            select_visible.find('option[value="'+ block.attr('data-visible')).prop('selected', true);
        } else {
            select_visible.find('option[value="visible"]').prop('selected', true);
        }
        
        let select_session_types = modal.find('[name="session_types[]"]');
        let session_types = JSON.parse(block.attr('data-session-types'));
        if (typeof session_types == 'object' && session_types.length > 0) {
            session_types.forEach(element => {
                select_session_types.find('option[value="'+element+'"]').prop('selected', true);
            })

            select_session_types.select2({
                minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
                theme: 'bootstrap',
                width: 'resolve',
            });
        }

        select_visible.select2({
            minimumResultsForSearch: $(this).attr('minimumResultsForSearch') ?? 10,
            theme: 'bootstrap',
            width: 'resolve',
        });

    });

    $('#edit_speakers').on('submit', function (e) {

        e.preventDefault();

        let block = $('#'+ $(this).find('[name="block_id"]').val());
        block.attr('data-class', $(this).find('[name="classes"]').val());
        block.attr('data-visible', $(this).find('[name="visible"]').val());

        let device_mobile = $(this).find('.visibility-devices [data-device="mobile"]');
        block.attr('data-mobile-hidden', device_mobile.attr('data-hidden'));
        
        let device_tablet = $(this).find('.visibility-devices  [data-device="tablet"]');
        block.attr('data-tablet-hidden', device_tablet.attr('data-hidden'));
        
        let device_desktop = $(this).find('.visibility-devices [data-device="desktop"]');
        block.attr('data-desktop-hidden', device_desktop.attr('data-hidden'));

        let session_types = $(this).find('[name="session_types[]"]').val();
        block.attr('data-session-types', JSON.stringify(session_types));

        block.attr('data-photo', $(this).find('[name="photo"]').prop('checked'));
        block.attr('data-title', $(this).find('[name="title"]').prop('checked'));
        block.attr('data-position', $(this).find('[name="position"]').prop('checked'));
        block.attr('data-work-place', $(this).find('[name="work_place"]').prop('checked'));
        block.attr('data-moderators', $(this).find('[name="moderators"]').prop('checked'));
        block.attr('data-speakers', $(this).find('[name="speakers"]').prop('checked'));
        block.attr('data-communicators', $(this).find('[name="communicators"]').prop('checked'));
        block.attr('data-show-details', $(this).find('[name="show_details"]').prop('checked'));
        block.attr('data-show-details-photo', $(this).find('[name="show_details_photo"]').prop('checked'));
        block.attr('data-show-details-title', $(this).find('[name="show_details_title"]').prop('checked'));
        block.attr('data-show-details-position', $(this).find('[name="show_details_position"]').prop('checked'));
        block.attr('data-show-details-work-place', $(this).find('[name="show_details_work_place"]').prop('checked'));
        block.attr('data-show-details-curriculum', $(this).find('[name="show_details_curriculum"]').prop('checked'));
        block.attr('data-show-details-description', $(this).find('[name="show_details_description"]').prop('checked'));
        block.attr('data-show-details-sesions', $(this).find('[name="show_details_sesions"]').prop('checked'));
        
        content_blocks.change_visible_button_blocks(block);
        change_view(block);
        let modal = $(this).closest('.modal');
        modal.modal('hide');

    });

    $('#edit_speakers input[name="show_details"]').on('click',function() {
        let modal = $(this).closest('.modal');
        let block_id = modal.find('[name="block_id"]').val();
        let block = $('#'+block_id);
        change_show_details(modal, block);
    });

    // $('#edit_speakers input[name="show_moderators"]').on('click',function() {
    //     let modal = $(this).closest('.modal');
    //     let block_id = modal.find('[name="block_id"]').val();
    //     let block = $('#'+block_id);
    //     change_user_info(modal, block);
    // });

    // $('#edit_speakers input[name="show_authors"]').on('click',function() {
    //     let modal = $(this).closest('.modal');
    //     let block_id = modal.find('[name="block_id"]').val();
    //     let block = $('#'+block_id);
    //     change_user_info(modal, block);
    // });

    $('.block[data-type="speakers"]').each(function() {
        content_blocks.create_visible_button_blocks($(this));
    })
}


function change_show_details(modal, block){
    
    let show_detail = modal.find('input[name="show_details"]').prop('checked');

    let disabled = show_detail == true ? false : true;

    let show_details_photo = modal.find('input[name="show_details_photo"]');
    let show_details_title = modal.find('input[name="show_details_title"]');
    let show_details_position = modal.find('input[name="show_details_position"]');
    let show_details_work_place = modal.find('input[name="show_details_work_place"]');
    let show_details_curriculum = modal.find('input[name="show_details_curriculum"]');
    let show_details_description = modal.find('input[name="show_details_description"]');
    let show_details_sesions = modal.find('input[name="show_details_sesions"]');

    show_details_photo.attr('disabled', disabled);
    show_details_title.attr('disabled', disabled);
    show_details_position.attr('disabled', disabled);
    show_details_work_place.attr('disabled', disabled);
    show_details_curriculum.attr('disabled', disabled);
    show_details_description.attr('disabled', disabled);
    show_details_sesions.attr('disabled', disabled);

    show_details_photo.prop('checked', disabled ? false : (block.attr('data-show-details-photo') == "true") ? true : false);
    show_details_title.prop('checked', disabled ? false : (block.attr('data-show-details-title') == "true") ? true : false);
    show_details_position.prop('checked', disabled ? false : (block.attr('data-show-details-position') == "true") ? true : false);
    show_details_work_place.prop('checked', disabled ? false : (block.attr('data-show-details-work-place') == "true") ? true : false);
    show_details_curriculum.prop('checked', disabled ? false : (block.attr('data-show-details-curriculum') == "true") ? true : false);
    show_details_description.prop('checked', disabled ? false : (block.attr('data-show-details-description') == "true") ? true : false);
    show_details_sesions.prop('checked', disabled ? false : (block.attr('data-show-details-sesions') == "true") ? true : false);
}

function change_view(block){

    let session_types = "";
    let session_types_array = JSON.parse(block.attr('data-session-types'));
    session_types_array.forEach(function(element, index) {
        element = $('<textarea />').html(element).text();
        let session_obj = JSON.parse(element);
        session_types += "<li>" + Object.values(session_obj)[0] + "</li>";
    });
    block.find('ul[show="session_types"]').html(session_types);

    block.find('li[show="moderators"]').attr('class', block.attr('data-moderators') == "true" ? '' : 'program_hidden');
    block.find('li[show="speakers"]').attr('class', block.attr('data-speakers') == "true" ? '' : 'program_hidden');
    block.find('li[show="communicators"]').attr('class', block.attr('data-communicators') == "true" ? '' : 'program_hidden');

    block.find('li[show="photo"]').attr('class', block.attr('data-photo') == "true" ? '' : 'program_hidden');
    block.find('li[show="title"]').attr('class', block.attr('data-title') == "true" ? '' : 'program_hidden');
    block.find('li[show="position"]').attr('class', block.attr('data-position') == "true" ? '' : 'program_hidden');
    block.find('li[show="work_place"]').attr('class', block.attr('data-work-place') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_details"]').attr('class', block.attr('data-show-details') == "true" ? '' : 'program_hidden');

    block.find('li[show="show_details_photo"]').attr('class', block.attr('data-show-details-photo') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_details_title"]').attr('class', block.attr('data-show-details-title') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_details_position"]').attr('class', block.attr('data-show-details-position') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_details_work_place"]').attr('class', block.attr('data-show-details-work-place') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_details_curriculum"]').attr('class', block.attr('data-show-details-curriculum') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_details_description"]').attr('class', block.attr('data-show-details-description') == "true" ? '' : 'program_hidden');
    block.find('li[show="show_details_sesions"]').attr('class', block.attr('data-show-details-sesions') == "true" ? '' : 'program_hidden');

}